<div class="mapeo-wrap">

  <!-- Encabezado -->
  <div class="mapeo-header">
    <div class="mapeo-titulo">{{ lista1.titulo || titulo }}</div>
  </div>

  <!-- Cuerpo: sidebar de filtros (izquierda) + listas (derecha) -->
  <div class="mapeo-body">

    <!-- SIDEBAR (delgado, fijo a la izquierda): Operaciones arriba, Filtros abajo -->
    <aside class="mapeo-sidebar" *ngIf="toolbar?.length || camposFiltro.length">

      <!-- [2] OPERACIONES (botonera del toolbar, incluye SYS16EVE=MAPEO) -->
      <div class="mapeo-operaciones" *ngIf="toolbar?.length">
        <div class="seccion-titulo"><i class="fas fa-bolt"></i> Operaciones</div>
        <div class="operaciones-botones">
          <button *ngFor="let boton of toolbar" type="button"
            class="btn btn-toolbar-mapeo"
            [title]="boton.Tooltip || boton.boton"
            [ngStyle]="{ 'background-color': boton.class }"
            (click)="ejecutarBoton(boton)">
            <i class="fas {{ boton.icono }} label-icon" *ngIf="boton.icono"></i>
            {{ boton.boton }}
          </button>
        </div>
      </div>

      <!-- [1]+[3] FILTROS (debajo de Operaciones) -->
      <div class="mapeo-filtros" *ngIf="camposFiltro.length">
      <div class="filtros-titulo"><i class="fas fa-filter"></i> Filtros</div>

      <ng-container *ngFor="let campo of camposFiltro">
        <div class="filtro-campo">
          <label [attr.for]="'flt_' + campo.label">{{ campo.title }}</label>

          <ng-container [ngSwitch]="campo.type">
            <select *ngSwitchCase="'select'" [id]="'flt_' + campo.label"
              class="form-control form-control-sm" [(ngModel)]="filtroModel[campo.label]">
              <option value="">-- Todos --</option>
              <option *ngFor="let o of campo.options" [value]="o.value">{{ o.text }}</option>
            </select>

            <select *ngSwitchCase="'select_multiple'" [id]="'flt_' + campo.label" multiple
              class="form-control form-control-sm" [(ngModel)]="filtroModel[campo.label]">
              <option *ngFor="let o of campo.options" [value]="o.value">{{ o.text }}</option>
            </select>

            <input *ngSwitchCase="'textbox_date'" type="date" [id]="'flt_' + campo.label"
              class="form-control form-control-sm" [(ngModel)]="filtroModel[campo.label]">

            <div *ngSwitchCase="'checkbox'" class="form-check form-switch">
              <input type="checkbox" [id]="'flt_' + campo.label"
                class="form-check-input" [(ngModel)]="filtroModel[campo.label]">
            </div>

            <input *ngSwitchDefault type="text" [id]="'flt_' + campo.label"
              class="form-control form-control-sm" [placeholder]="campo.placeholder || ''"
              [(ngModel)]="filtroModel[campo.label]" (keyup.enter)="buscar()">
          </ng-container>
        </div>
      </ng-container>

      <div class="filtros-acciones">
        <button type="button" class="btn btn-info btn-sm w-100" (click)="buscar()">
          <i class="bx bx-search-alt-2"></i> Buscar
        </button>
        <button type="button" class="btn btn-light btn-sm w-100" (click)="limpiarFiltros()">
          Limpiar
        </button>
      </div>
      </div>
      <!-- /.mapeo-filtros -->
    </aside>

    <!-- CONTENIDO: las dos listas -->
    <div class="mapeo-listas">

      <!-- LISTA DE SELECCION 1 -->
      <div class="mapeo-subtitulo">{{ lista1.titulo || 'Lista 1' }}</div>
      <ng-container *ngTemplateOutlet="grid; context: { lista: lista1 }"></ng-container>

      <!-- LISTA DE SELECCION 2 -->
      <div class="mapeo-subtitulo">{{ lista2.titulo || 'Lista 2' }}</div>
      <ng-container *ngTemplateOutlet="grid; context: { lista: lista2 }"></ng-container>

    </div>
  </div>
</div>


<!-- ===== Template reutilizable de grid con seleccion multiple ===== -->
<ng-template #grid let-lista="lista">
  <div class="table-responsive mapeo-grid">
    <table class="table-avatar mb-0 table-striped">
      <thead>
        <tr class="thead">
          <td class="col-check">
            <a class="form-check">
              <input class="form-check-input" type="checkbox"
                [checked]="lista.todos"
                (change)="marcarTodos(lista, $event.target.checked)">
            </a>
          </td>
          <td *ngFor="let col of lista.columnas">{{ col.A03DES }}</td>
          <!-- columna de operaciones (sticky a la derecha) -->
          <td class="col-ops" *ngIf="lista.operaciones.length">Operaciones</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!lista.cargando && lista.filas.length === 0">
          <td [colSpan]="lista.columnas.length + (lista.operaciones.length ? 2 : 1)">
            No se encuentra informacion que cumpla con los filtros indicados.
          </td>
        </tr>
        <tr *ngIf="lista.cargando">
          <td [colSpan]="lista.columnas.length + (lista.operaciones.length ? 2 : 1)">Cargando...</td>
        </tr>
        <tr *ngFor="let fila of lista.filas">
          <td class="col-check">
            <a class="form-check">
              <input class="form-check-input" type="checkbox"
                [(ngModel)]="fila.checkado"
                (change)="onCheckFila(lista)">
            </a>
          </td>
          <td *ngFor="let col of lista.columnas"
            [ngClass]="{ 'to-right': alineaDerecha(col) }"
            [title]="fila[col.A03COD]">
            <!-- span recortable: si el texto es muy largo se corta con "..."; el completo va en el title (hover) -->
            <span class="celda-txt">{{ fila[col.A03COD] }}</span>
          </td>
          <!-- [4] botonera de operaciones de la fila (sticky a la derecha) -->
          <td class="col-ops" *ngIf="lista.operaciones.length">
            <button *ngFor="let op of lista.operaciones" type="button"
              class="btn-op"
              [title]="op.boton"
              [ngStyle]="{ 'background-color': op.class }"
              (click)="ejecutarOperacion(lista, fila, op)">
              <i class="fas {{ op.icono }}"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginacion servidor -->
  <div class="mapeo-paginacion">
    <button type="button" class="btn btn-sm btn-light"
      [disabled]="lista.pagina <= 1 || lista.cargando"
      (click)="paginaAnterior(lista)" title="Anterior">
      <i class="fa-solid fa-caret-left"></i>
    </button>
    <span class="pagina-label">Pagina {{ lista.pagina }}</span>
    <button type="button" class="btn btn-sm btn-light"
      [disabled]="!lista.hayMas || lista.cargando"
      (click)="paginaSiguiente(lista)" title="Siguiente">
      &gt;&gt;
    </button>
  </div>
</ng-template>
